import { FileTextIcon, ZapIcon, BabyIcon, SmartphoneIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: 'Complete eBook (PDF)'
}, {
  icon: ZapIcon,
  label: 'Ready to print'
}, {
  icon: BabyIcon,
  label: 'Ages 3 to 12'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}];
export const stats = [{
  value: "+500",
  label: "Happy families"
}, {
  value: "6+5",
  label: "Volumes + Bonus included"
}, {
  value: "99%",
  label: "Would recommend it"
}, {
  value: '4.9/5',
  label: 'Parent rating ⭐'
}];